<!-- 설정 화면.
     2026-09-02 에 시리즈 수정만 남기고 전부 걷어냈다.

     걷어낸 것은 모두 데일리안 잔재이고, 중앙신문 스키마로 이관되지 않아
     이미 동작하지 않던 것들이다.
       · 코로나 현황판 / 올림픽 / 2022대선 / 월드컵  — 템플릿에서 이미 주석 상태였다
       · 선거 특집(키워드·격전지·지난선거)
       · 배너 태그 생성기
       · 사이드바 순서(메인/기사/리뉴얼)  — sidebar_media_position
       · 메인 콘텐츠 배치               — main_contents_position
     뒤 둘은 테이블이 (id, name, sort) 같은 새 스키마로 만들어졌는데 화면과 API 는
     데일리안 컬럼(smp_title / mcp_uid / mcp_pageType)을 요구해 쿼리부터 실패했다.
     되살리려면 스키마와 화면을 함께 이관해야 한다.

     설정 DB(setting 테이블) 읽기는 그대로 둔다 — /api/getVarList 의 [5] 블록. -->
<template>
  <div id="setting" style="padding-left: 10px;">
    <div>
      <feather-icon class="sm:inline-flex xl:hidden cursor-pointer" icon="MenuIcon"
                    style="height: 20px; margin-right: 10px;" @click.stop="showSidebar"></feather-icon>
    </div>

    <section class="home-display-settings" aria-labelledby="home-display-title">
      <h2 id="home-display-title">메인페이지 표시</h2>
      <p>뉴데일리 TV 영상 영역을 홈페이지에 표시할지 설정합니다.</p>
      <label class="home-display-toggle"><input type="checkbox" v-model="newdailyTvEnabled" :disabled="displayLoading || displaySaving || !displayLoaded"> 뉴데일리 TV 표시 <strong>{{ newdailyTvEnabled ? '표시' : '숨김' }}</strong></label>
      <p class="home-display-help">저장 후 최대 5초 안에 반영됩니다. 표시를 켜도 수집된 영상이 없으면 영역은 나타나지 않습니다.</p>
      <button type="button" @click="saveHomeDisplay" :disabled="displayLoading || displaySaving || !displayLoaded || newdailyTvEnabled===savedNewdailyTv">{{ displaySaving ? '저장 중…' : '표시 설정 저장' }}</button>
      <button v-if="displayError" type="button" @click="loadHomeDisplay" :disabled="displayLoading || displaySaving">다시 불러오기</button>
      <p v-if="displayLoading" role="status">설정을 불러오는 중입니다.</p>
      <p v-if="displayNotice" role="status">{{ displayNotice }}</p>
      <p v-if="displayError" class="home-display-error" role="alert">{{ displayError }}</p>
    </section>
    <div>
      <v-select style="width: 200px" placeholder="시리즈 수정" label="name"
                :options="seriesArray" @input="setSeries"/>
    </div>

    <!-- Start: 시리즈 수정 팝업 -->
    <div id="div-with-loading" class="news-detail-form vs-con-loading__container" style="width: 690px;">
      <vs-popup ref="popup-editSeries" classContent="popup-editSeries" title="시리즈 수정"
                :active.sync="seriesEditModalActive">
        <div class="vx-row" style="margin: 10px">
          <div class="vx-col sm:w-1/3 w-full"><span>시리즈 이름: </span></div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" placeholder="이름 입력" v-model="seriesVar.name"/>
          </div>
        </div>
        <div class="vx-row" style="margin: 10px">
          <div class="vx-col sm:w-1/3 w-full"><span>시리즈 설명: </span></div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" placeholder="설명 입력" v-model="seriesVar.description"/>
          </div>
        </div>
        <div class="vx-row" style="margin: 10px">
          <div class="vx-col sm:w-1/3 w-full"><span>해당 카테고리: </span></div>
          <div class="vx-col sm:w-2/3 w-full">
            <v-select style="width: 150px" placeholder="카테고리" label="name" v-model="category1"
                      :options="category1Array" :clearable="false"/>
          </div>
        </div>
        <div class="vx-row" style="margin: 10px">
          <div class="vx-col sm:w-1/3 w-full"><span>시리즈 사용여부: </span></div>
          <div class="vx-col sm:w-2/3 w-full">
            <v-select style="width: 150px" placeholder="사용 여부" label="text" v-model="on_use"
                      :options="seriesUseOption" :clearable="false"/>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full"><span>시리즈 아이콘</span></div>
          <div class="vx-col sm:w-2/3 w-full">
            <div class="seriesBanner">
              <form class="drag-drop" ref="fileform">
                <label class="drop-files"><p>여기를 클릭하거나 파일을 드래그해서 넣어주세요</p>
                  <input type="file" @change="addFile"></label>
                <progress max="100" :value.prop="uploadPercentage"></progress>
              </form>
              <img :src="preview" style="width: 200px;">
            </div>
          </div>
        </div>
        <div class="vx-row" style="margin: 10px">
          <div class="vx-col sm:w-2/3 w-full ml-auto">
            <vs-button class="mr-3 mb-2" @click="sendSeries()">{{ buttonText }}</vs-button>
            <vs-button color="warning" type="border" class="mb-2"
                       @click="seriesEditModalActive=false">취소</vs-button>
          </div>
        </div>
      </vs-popup>
    </div>
    <!-- End: 시리즈 수정 팝업 -->
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: { vSelect },
  data() {
    return {
      newdailyTvEnabled: false, savedNewdailyTv: false, displayLoaded: false,
      displayLoading: false, displaySaving: false, displayError: '', displayNotice: '',
      seriesEditModalActive: false,
      seriesVar: {
        code: '',
        name: '',
        description: '',
        category1: '0',
        banner: '',
        on_use: null,
      },
      category1: {},
      on_use: null,
      seriesArray: [],
      category1Array: [],
      seriesUseOption: [
        { text: "사용", value: "1" },
        { text: "숨김", value: "0" },
      ],
      buttonText: "수정",

      // setting 테이블 값. 화면에서 쓰지는 않지만 읽어 둔다(요청).
      settingData: [],

      // 시리즈 아이콘 업로드
      files: [],
      preview: '',
      uploadPercentage: 0,
      dragAndDropCapable: false,
    }
  },
  methods: {
    async loadHomeDisplay() {
      this.displayLoading=true;this.displayError='';this.displayNotice='';this.displayLoaded=false;
      try {
        const r=await this.$http.post('/api/setting/getSetting',{code:'home'});
        const row=r.data.find(x=>x.name==='newdailyTv');
        this.newdailyTvEnabled=!!row && row.value==='1';
        this.savedNewdailyTv=this.newdailyTvEnabled;this.displayLoaded=true;
      } catch(e) { this.displayError='표시 설정을 불러오지 못했습니다. 다시 시도해 주세요.'; }
      finally { this.displayLoading=false; }
    },
    async saveHomeDisplay() {
      if(!this.displayLoaded || this.displaySaving || this.displayLoading)return;
      this.displaySaving=true;this.displayError='';this.displayNotice='';
      const enabled=this.newdailyTvEnabled;
      try {
        await this.$http.post('/api/setting/setting',{code:'home',data:{newdailyTv:enabled?'1':'0'}});
        this.savedNewdailyTv=enabled;
        this.displayNotice='뉴데일리 TV를 '+(enabled?'표시':'숨김')+'으로 저장했습니다. 홈페이지를 새로 열어 확인해 주세요.';
      } catch(e) { this.displayError='저장하지 못했습니다. 입력한 설정을 확인한 뒤 다시 저장해 주세요.'; }
      finally { this.displaySaving=false; }
    },
    // /api/getVarList 응답은 **인덱스 배열**이다. 서버(getVarList.js)의 순서와 계약이라
    // 한쪽만 바꾸면 어긋난다.
    //   [0] 대분류  [1] 중분류  [2] 기사상태  [3] 회원  [4] 시리즈  [5] 설정
    created() {
      const thisIns = this;
      this.$http.post('/api/getVarList')
        .then(function (res) {
          thisIns.category1Array = [{ code: 0, name: '전체' }].concat(res.data[0]);
          thisIns.seriesArray = [{ code: 'new', name: '신규 시리즈 생성' }].concat(res.data[4]);
          thisIns.settingData = res.data[5] || [];
        })
        .catch(function (error) {
          if (String(error).includes('401')) {
            alert('로그인 해주세요!');
            thisIns.$router.push({
              path: '/pages/login?to=' + thisIns.$router.history.current.path,
              query: thisIns.$router.history.current.query,
            });
          }
        });
    },

    setSeries(e) {
      if (e == null) return;
      if (e.code != 'new') {
        this.buttonText = "수정";
        this.seriesVar = JSON.parse(JSON.stringify(this.seriesArray.find(d => d.code == e.code)));
        this.on_use = this.seriesUseOption.find(d => d.value == this.seriesVar.on_use);
        this.category1 = this.category1Array.find(d => d.code == e.category1);
        // 저장된 배너는 Object Storage 의 news/series/ 에 있다. viewImages 는
        // phototmp/(업로드 직후)만 읽으므로 저장분은 여기서 404 가 났다.
        // 도메인은 박지 않는다 — /news 라우트가 로컬 → CDN → 옛 사이트 순으로 찾는다.
        this.preview = this.seriesVar.banner ? '/news/series/' + this.seriesVar.banner : '';
      } else {
        this.seriesVar = { code: 'new', name: '', description: '', category1: '0', banner: '', on_use: null };
        this.category1 = this.category1Array.find(d => d.code == 0);
        this.on_use = this.seriesUseOption.find(d => d.value == 1);
        this.preview = '';
        this.buttonText = "생성";
      }
      this.seriesEditModalActive = true;
    },

    sendSeries() {
      if (this.on_use == null) {
        alert('사용 여부를 선택하세요!');
        return;
      }
      this.seriesVar.on_use = this.on_use.value;
      this.seriesVar.category1 = this.category1 ? this.category1.code : 0;

      this.$vs.loading({ scale: 1.5 });
      const thisIns = this;
      this.$http.post('/api/setting/series', this.seriesVar)
        .then(function () {
          thisIns.$vs.notify({
            title: '성공', text: '시리즈 수정 완료',
            color: 'primary', iconPack: 'feather', icon: 'icon-alert-circle',
          });
          thisIns.created();
          thisIns.seriesEditModalActive = false;
          thisIns.$vs.loading.close();
        })
        .catch(function (error) {
          if (String(error).includes('401')) {
            alert('로그인 해주세요!');
            thisIns.$router.push({
              path: '/pages/login?to=' + thisIns.$router.history.current.path,
              query: thisIns.$router.history.current.query,
            });
          }
          thisIns.$vs.notify({
            title: 'Error', text: error,
            color: 'danger', iconPack: 'feather', icon: 'icon-alert-circle',
          });
          thisIns.seriesEditModalActive = false;
          thisIns.$vs.loading.close();
        });
    },

    addFile(e) {
      if (e.target.files.length) {
        this.files[0] = e.target.files[0];
        this.submitFiles(e.target.files);
      }
    },

    submitFiles(files) {
      const formData = new FormData();
      const thisIns = this;
      for (let i = 0; i < files.length; i++) formData.append('file', files[i]);
      formData.append('type', 11);
      formData.append('partName', thisIns.seriesVar.code);

      this.$http.post('/api/fileUpload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
        }.bind(this),
      }).then(function (response) {
        if (response.data.length) {
          thisIns.seriesVar.banner = response.data[0];
          thisIns.preview = '/api/photo/viewImages?filename=' + response.data[0];
        }
      }).catch(function (error) {
        console.log('시리즈 아이콘 업로드 실패:', error);
      });
    },

    determineDragAndDropCapable() {
      const div = document.createElement('div');
      return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div))
        && 'FormData' in window && 'FileReader' in window;
    },

    showSidebar() {
      this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
    },
  },
  created() {
    this.created();
    this.loadHomeDisplay();
  },
  mounted() {
    this.dragAndDropCapable = this.determineDragAndDropCapable();
    if (!this.dragAndDropCapable || !this.$refs.fileform) return;

    ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach((evt) => {
      this.$refs.fileform.addEventListener(evt, function (e) {
        e.preventDefault();
        e.stopPropagation();
      }.bind(this), false);
    });

    this.$refs.fileform.addEventListener('drop', function (e) {
      if (e.dataTransfer.files.length) {
        this.files[0] = e.dataTransfer.files[0];
        this.submitFiles(e.dataTransfer.files);
      }
    }.bind(this));
  },
}
</script>

<style lang="scss">
.home-display-settings{max-width:760px;margin:18px 0 28px;padding:24px;background:white;border:1px solid #dce3eb;border-radius:8px}.home-display-settings h2{font-size:20px;margin-bottom:12px}.home-display-settings p{line-height:1.6;margin:10px 0}.home-display-toggle{display:flex;align-items:center;gap:10px;margin:20px 0;font-size:16px}.home-display-toggle input{width:20px;height:20px;accent-color:#2865b1}.home-display-toggle strong{font-size:13px;color:#365779;background:#edf3f9;padding:3px 9px;border-radius:4px}.home-display-help{font-size:13px;color:#68778a}.home-display-settings button{padding:10px 16px;border:0;border-radius:5px;background:#2865b1;color:white;cursor:pointer;margin-right:8px}.home-display-settings button:disabled{opacity:.5;cursor:default}.home-display-error{color:#a92b2b}
.popup-editSeries {
  .seriesBanner {
    form {
      display: inline-block;
      height: 150px;
      width: 150px;
      background: #ccc;
      text-align: center;
      border-radius: 4px;
      vertical-align: bottom;
    }
    .drop-files {
      p {
        padding-top: 50px;
        height: 100%;
      }
    }
    input[type="file"] { /* 파일 필드 숨기기 */
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
    }
    progress {
      width: 150px;
      margin: auto;
      display: block;
      margin-top: -20px;
    }
  }
}
</style>
